import React, { useMemo } from "react";
import { Card, Empty, Spin, Typography } from "antd";
import { RingProgress } from "@ant-design/plots";
import { LoadingOutlined } from "@ant-design/icons";

const { Title } = Typography;
const antIcon = <LoadingOutlined spin />;

const ConnectedUsersChart = ({ percent, loading, small, minHeight }) => {
  const config = useMemo(() => ({
    percent,
    autoFit: true,
    appendPadding: small ? 0 : 8,
    radius: small ? 0.6 : 0.8,
    innerRadius: small ? 0.6 : 0.7,
    color: ['#66AFF4', '#E8EFF5'],
    statistic: {
      title: false,
      content: {
        customHtml: () => `
          <div style="text-align: center;">
            <div style="font-size: ${small ? 18 : 32}px; font-weight: bold; color: #333;">
              ${(percent * 100).toFixed(1)}%
            </div>
            <div style="font-size: ${small ? 10 : 14}px; color: #666;">
              User Connected
            </div>
          </div>
        `,
      },
    },
  }), [percent, small]);

  return (
    <Card className="custom-card-graph" title={<Title level={3}>Connected User</Title>} bodyStyle={{ minHeight: 120, padding: 0  }}>
      <Spin
        indicator={antIcon}
        spinning={loading}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: minHeight || (small ? 80 : 200) }}
      >
        {percent !== null ? <RingProgress {...config} /> : <Empty />}
      </Spin>
    </Card>
  );
};

export default ConnectedUsersChart;
